export interface UserSettings {
  lang: string;
  units: 'metric' | 'imperial';
  theme: 'light' | 'dark';
  map?: string;
}

export interface User {
  uid: string;
  customerId: string | null;
  name: string | null;
  guest: boolean;
  email: string | null;
  photoUrl: string | null;
  consents: {
    cookie: boolean;
    privacy: boolean;
  };
  settings: UserSettings;
}

export interface Users {
  [userId: string]: User;
}

export const defaultUser = (): User => {
  return {
    uid: '',
    customerId: '',
    name: 'Guest',
    guest: true,
    email: '',
    photoUrl: null,
    consents: {
      cookie: false,
      privacy: false
    },
    settings: {
      lang: 'da',
      units: 'metric',
      theme: 'light'
    }
  }
}

export const User = (user?: Partial<User> | null): User => {
  return { ...defaultUser(), ...user }
}